import { render, staticRenderFns } from "./IconSvgStar.vue?vue&type=template&id=a5ea52be&scoped=true&"
import script from "./IconSvgStar.vue?vue&type=script&lang=js&"
export * from "./IconSvgStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ea52be",
  null
  
)

export default component.exports